import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AlertController } from '@ionic/angular/standalone';

/** Lo que una página expone para que el guard sepa si hay algo por perder. */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

/**
 * Pregunta antes de salir de una página con cambios sin guardar.
 *
 * Sin cambios deja salir sin preguntar. Con cambios, solo sale si la persona
 * elige "Salir sin guardar"; cerrar la alerta cuenta como quedarse.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = async (component) => {
  if (!component?.hasUnsavedChanges()) {
    return true;
  }

  const alert = await inject(AlertController).create({
    header: 'Tienes cambios sin guardar',
    message: 'Si sales ahora, se pierden.',
    buttons: [
      { text: 'Seguir editando', role: 'cancel' },
      { text: 'Salir sin guardar', role: 'confirm' },
    ],
  });
  await alert.present();
  const { role } = await alert.onDidDismiss();
  return role === 'confirm';
};
